/**
 * UrlUtils
 * Utilites common for URL operations
 */

export default class UrlUtils {
  constructor(opts = {}) {
    this.locale = opts.locale || '';
    this.subDir = opts.subDir || '';
  }

  static getBaseUrl(localeless = true) {
    const localePath = localeless ? '' : this.locale;
    const subDirPath = !this.subDir ? '' : this.subDir;
    const base = window.location.origin;
    let url = base;

    if (localePath) url += `/${localePath}`;
    if (subDirPath) url += `/${subDirPath}`;

    return url;
  }
}
